import React, { useCallback, useEffect, useMemo, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import {
  Button,
  Form,
  Popconfirm,
  //   Radio,
  Row,
  Select,
  Spin,
  Tag,
  message,
  notification,
} from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form/Form';
import {
  FinContractResponse,
  getFinContractById,
  getFinModificationByModid,
  getFinModificationValidByCtrid,
} from 'services/fincontract';
import { useQuery } from 'react-query';
import UtinaCard from 'components/UtinaCard';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { dateToString, setValueByNamePath } from 'utils/utils2';
import { toCurrency, toPercentage } from 'utils/utils';
import InputCurrency from 'components/InputCurrency';
import _, { groupBy, isNil } from 'lodash';
import { calculatePrefinInterestByContract } from 'services/clientInvoice';
import moment from 'moment';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import { PricingResponse } from 'services/pricing';
import * as finEngine from 'services/finEngine';
import Value from 'components/Value';
import ServiceScheduleModal from 'components/ServiceScheduleModal';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ConvertButton from 'components/convertButton';
import ScheduleButton from 'components/ScheduleButton';
import SpreadingScheduleModal from 'components/SpreadingScheduleModal';
import IfrsScheduleModal from 'components/IfrsScheduleModal';
import DeleteButton from 'components/DeleteButton';
import SimpleServElementModal from './components/SimpleServElementModal';
import ModalControllerNV from 'components/ModalControllerNV';
import ButtonOperation from 'components/ButtonOperation';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type TabProps = {
  form: FormInstance;
  objectid: number;
  setSuccessful: any;
};

const TabReschedulingService = ({
  objectid,
  form,
  setSuccessful,
}: TabProps) => {
  const [mode, setMode] = useState('SIMUL');
  const [isLoading, setisLoading] = useState('');

  const [serviceToStop, setServiceToStop] = useState<any[]>([]);

  let [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

  const { data: modList } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'SERVRESCH',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  const { data: contract, isFetching } = useQuery(
    ['getFinContractById', objectid],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data),
    {
      refetchOnWindowFocus: false,
    }
  );

  //   const updateState = useCallback(
  //     (values) => {
  //       setState((prev) => ({ ...prev, ...values }));
  //     },
  //     [setState]
  //   );
  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      //   updateState({ isModSelected: false });
      return;
    }

    // updateState({ isLoading: true });

    let query = getFinModificationByModid({ modid: finmod });
    setisLoading('POFF');
    query
      .then((response) => {
        if (response.code !== '200') {
          return;
        }
        const res = response.data;

        let elemList = res.simulParams.find(
          (item) => item.parcode === 'ELEMENTS' && item.partype === 'IN'
        )?.finModSimulParamElements;
        let effectDate = res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue;

        reset(effectDate);
        form?.setFieldsValue({
          mode: 'REAL',

          ctenddate: Number(
            res.simulParams.find(
              (item) => item.parcode === 'ENDDATE' && item.partype === 'IN'
            )?.newvalue
          ),

          inPartialPayoffAmount: res.simulParams.find(
            (item) => item.parcode === 'INPPOFFAMT' && item.partype === 'IN'
          )?.newvalue,

          payOffFormula: Number(
            res.simulParams.find(
              (item) => item.parcode === 'INPPOFFORM' && item.partype === 'IN'
            )?.newvalue
          ),

          payOffFeesAmount: Number(
            res.simulParams.find(
              (item) => item.parcode === 'INPPOFFEES' && item.partype === 'IN'
            )?.newvalue
          ),

          comment: response.data.modcomment,

          feesFormula: Number(
            res.simulParams.find(
              (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
            )?.newvalue
          ),
          feesAmount: res.simulParams.find(
            (item) => item.parcode === 'FEESAMNT' && item.partype === 'IN'
          )?.newvalue,

          modreason: res.simulParams.find(
            (item) => item.parcode === 'MODREASON' && item.partype === 'IN'
          )?.newvalue,

          serviceList: elemList,
          payOffAmount: _.sumBy(elemList, 'payOffAmount'),
          newOutstanding: _.sumBy(elemList, 'newoutstandingamount'),
        });

        calculatePreFin(effectDate);

        let selectElem: any = elemList
          ?.filter((el) => el.flagpayoff)
          .map((e) => e.cteid);

        setSelectedRowKeys(selectElem);
        /* handleEffectDateChange(
        res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue
      );*/

        const targetDate = form?.getFieldValue('effectDate');

        const defintMethod = form?.getFieldValue('defintMethod');
        const newDueDate = form?.getFieldValue('newDueDate');
        const defintNominalRate = form?.getFieldValue('defintNominalRate');

        const gpDuration = form?.getFieldValue('gpDuration');
        const gpMethod = form?.getFieldValue('gpMethod');
        const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
        const gpNominalRate = form?.getFieldValue('gpNominalRate');
        const extendDuration =
          gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');

        const inPartialPayoffAmount = form?.getFieldValue(
          'inPartialPayoffAmount'
        );
        const inPartialPayoffFormula = form?.getFieldValue(
          'inPartialPayoffFormula'
        );
        const inPartialPayoffFeesAmount = form?.getFieldValue(
          'inPartialPayoffFeesAmount'
        );

        const newRate = form?.getFieldValue('newRate');

        const newRv = form?.getFieldValue('newRv');

        const newDuration = form?.getFieldValue('newDuration');

        /*calculate(
        objectid,
        newRv ?? rvDefault,
        gpDuration,
        gpMethod,
        gpPeriodicity,
        gpNominalRate,
        extendDuration,
        newDuration,
        newRate,
        0,
        '',
        targetDate,
        newDueDate,
        defintMethod,
        defintNominalRate,
        inPartialPayoffAmount,
        inPartialPayoffFormula,
        inPartialPayoffFeesAmount
      );*/

        //   updateState({ isLoading: false });
      })
      .catch(() => {
        setisLoading('');
      });
  };

  const calculatePreFin = (calculationDate?: any) => {
    setisLoading('INTERSET');
    calculatePrefinInterestByContract({
      ctrid: objectid,
      mode: 'CALCUL',
      calculationDate:
        dateToString(calculationDate) ??
        dateToString(form.getFieldValue('effectDate')) ??
        dateToString(moment(new Date(), 'YYYY-MM-DD')),
      jobid: 0,
    })
      .then((response) => {
        setisLoading('');

        form.setFieldValue(
          'intereststoinvoice',
          _.sumBy(response.list, 'calculatedamount')
        );
      })
      .catch(() => {
        setisLoading('');
      });
  };

  const calculateFees = (
    pricing?: PricingResponse,
    updatePPOFFees?: boolean
  ) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: contract?.conElements[0]?.conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: contract?.conElements[0]?.ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.conElements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: contract?.conElements[0].cteduration ?? 0,
          inInvestAmount: contract?.conElements[0].cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0]?.assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          if (updatePPOFFees) {
            form?.setFieldsValue({
              payOffFeesAmount: res.installmentamount,
              payOffFormula: pricing?.priid,
            });
          } else {
            form?.setFieldsValue({
              feesAmount: res.installmentamount,
              feesFormula: pricing?.priid,
            });
          }
        }
      });
  };

  const [elementID, setElementID] = useState(1);

  const notInvoicedSchedule = contract?.conElements
    ?.find((e) => e.ctetype === 'FIN')
    ?.conElemSchedules.filter(
      (s) =>
        s.ciid === null &&
        s.ctstype !== 'UPFRONT' &&
        s.ctstype !== 'RV' &&
        s.ctstype !== 'DEFINT'
    );

  const optionDates = notInvoicedSchedule?.map(
    (e, index) =>
      e.ctstype !== 'UPFRONT' && (
        <option
          key={index}
          value={e.ctsduedate.toString()}
          selected={index === 0 ? true : false}
        >
          {e.ctsduedate}
        </option>
      )
  );

  const handleEffectDateChange = (value: any) => {
    const targetDate = form?.getFieldValue('effectDate');
    reset(targetDate);

    const oldRemainingDuration = form.getFieldValue('RemainingDuration');

    if (targetDate === '' || targetDate === undefined) {
      notification.error({ message: 'Please select a date' });
      return;
    }

    // //  no-// //
    // ////

    const defintMethod = form?.getFieldValue('defintMethod');
    const newDueDate = form?.getFieldValue('newDueDate');
    const defintNominalRate = form?.getFieldValue('defintNominalRate');

    const gpDuration = form?.getFieldValue('gpDuration');
    const gpMethod = form?.getFieldValue('gpMethod');
    const gpPeriodicity = form?.getFieldValue('gpPeriodicity');
    const gpNominalRate = form?.getFieldValue('gpNominalRate');
    const extendDuration =
      gpMethod === 'NONE' ? true : form?.getFieldValue('extendDuration');

    const inPartialPayoffAmount = form?.getFieldValue('inPartialPayoffAmount');
    const inPartialPayoffFormula = form?.getFieldValue(
      'inPartialPayoffFormula'
    );
    const inPartialPayoffFeesAmount = form?.getFieldValue(
      'inPartialPayoffFeesAmount'
    );

    const newRate = form?.getFieldValue('newRate');

    const newRemainingDuration =
      notInvoicedSchedule?.filter((e) => e.ctsduedate >= value).length ?? 0;

    const diffrenceRemainingDuration =
      oldRemainingDuration - newRemainingDuration;

    form.setFieldValue('RemainingDuration', newRemainingDuration);
  };

  const reset = (effectDate?: string) => {
    if (contract) {
      setSuccessful(false);
      setServiceToStop([]);
      let ct: FinContractResponse = contract;
      const elemFin = contract?.conElements?.find(
        (e) => e.ctetype === 'FIN' && e.ctestatus !== 'TERM'
      );

      let outstandingamount = _.sumBy(
        contract?.conElements?.filter(
          (e) => e.ctetype === 'FIN' && e.ctestatus !== 'TERM'
        ),
        'cteinvestamount'
      );

      let schedule = contract?.conElements
        ?.find((e) => e.ctetype === 'FIN')
        ?.conElemSchedules.filter(
          (s) =>
            s.ciid === null &&
            s.ctstype !== 'UPFRONT' &&
            s.ctstype !== 'RV' &&
            s.ctstype !== 'DEFINT'
        );


      let lastinvoicedate = '';
      let rental = 0;
      let lastinvoicedateFromSchedule = '';
      if (schedule) {
        if (effectDate) {
          lastinvoicedate = effectDate;
        } else {
          lastinvoicedate = schedule[0]?.ctsduedate;
        }
        lastinvoicedateFromSchedule = schedule[0]?.ctsduedate;
        rental = schedule[0]?.ctsrentalamount;
      }


      let totalInv = 0;
      let totalReim = 0;
      contract?.conElements.forEach((e) => {
        if (e.ctestatus === 'TERM') {
          totalReim = totalReim + e.cteinvestamount - e.ctervamount;
        }
        totalInv = totalInv + _.sumBy(e.conElemSchedules, 'ctsrentalamount');
      });

      const remainDuration =
        notInvoicedSchedule?.filter((e) => e.ctsduedate >= lastinvoicedate)
          .length ?? 0;


      form?.setFieldsValue({
        event: 'tabReschedulingService',
        offerid: ct?.offerid,
        ctactivationdate: ct?.ctactivationdate,
        mfusedamount: ct?.mfusedamount,
        ctenddate: ct?.ctenddate,
        ctfinancedamount: ct?.ctfinancedamount,
        lastinvoicedate: lastinvoicedateFromSchedule,
        totalreimbursment: totalReim,
        totalinvoicedamount: totalInv,
        outstandingamount: outstandingamount,
        newOutstanding: 0,
        intereststoinvoice: 0,
        currcode: contract.currcode,
        payOffAmount: 0,
        duree: elemFin?.cteduration,
        newRate: elemFin?.ctenominalrate,
        effectDate: lastinvoicedate,
        mode: 'SIMUL',
        comment: '',
        payid: '' as any,
        paymount: 0,
        selectedElement: 1,
        RemainingDuration: remainDuration,
        rental: rental,
        cteidparent: elemFin?.cteidparent==0 ? elemFin.cteid : elemFin?.cteidparent,
        assets: contract.assets,
      });
      setSelectedRowKeys([]);

      const {
        FIN = [],
        FINOUT = [],
        SPV = [],
        SERV = [],
        FEES = [],
        COMM = [],
        FINSERV = [],
        SERVOUT = [],
      } = groupBy(contract?.conElements, 'ctetype');

      const newRemainingDuration =
        notInvoicedSchedule?.filter((e) => e.ctsduedate >= lastinvoicedate)
          .length ?? 0;

      const oldRemainingDuration =
        notInvoicedSchedule?.filter(
          (e) => e.ctsduedate >= lastinvoicedateFromSchedule
        ).length ?? 0;

      const diffrenceRemainingDuration =
        oldRemainingDuration - newRemainingDuration;

      let NEW_SERV = SERV.map((s: any) => {
        const notInvoicedScheduleSERV = contract?.conElements
          ?.find((e) => e.cteid === s.cteid)
          ?.conElemSchedules.filter((s) => s.ciid === null);

        let lastinvoicedateService: string = '';
        if (effectDate) {
          lastinvoicedateService = effectDate;
        } else {
          if (
            !isNil(notInvoicedScheduleSERV) &&
            notInvoicedScheduleSERV.length > 0
          ) {
            lastinvoicedateService = notInvoicedScheduleSERV[0]?.ctsduedate;
          }
        }

        const remainDurationService =
          notInvoicedScheduleSERV?.filter(
            (e) => e.ctsduedate >= lastinvoicedateService
          ).length ?? 0;


        return {
          ...s,
          is_new: false,
          is_updated: false,
          stop: false,
          prilabel: s.ctedescription,
          oldservfixedamount: s.servfixedamount,
          servpercentage: s.servpercentage,
          oldservpercentage: s.servpercentage,
          servbasisamount: s.servbasis,
          remainingduration:
            remainDurationService > remainDuration ? 0 : remainDurationService,
          oldremainingduration:
            remainDurationService > remainDuration ? 0 : remainDurationService,
          overallduration: s.cteduration,
          oldoverallduration: s.cteduration,
          oldservbasisamount: s.servbasis,
        };
      }).filter((el) => el.ctestatus === 'ACTIVE');


      let _newElements: any = {
        COMM,
        FEES,
        FIN,
        FINOUT,
        SPV,
        FINSERV,
        SERV: NEW_SERV,
        SERVOUT,
      };

      form.setFieldsValue({
        elements: _newElements,
        serviceList: NEW_SERV,
      });
    }
  };


  const onSaveService = async (service: any, action: string) => {
    let cteid = form.getFieldValue('selectedElement');

    let finElement = form
      .getFieldValue(['elements', 'FIN'])
      .filter((e: any) => e.cteid === cteid);

    if (action === 'create') {
      let serviceList = form.getFieldValue('serviceList');
      if (service.ctetype === 'SERV') {
        const servs = [...serviceList];
        let new_servv = {
          ...service,
          is_new: true,
          stop: false,
          is_updated: false,
          cteid: Math.round(_.random(10000) * 10000000),
          remainingduration: service.cteduration,
          prilabel: service.ctedescription,
          overallduration: service.cteduration,
          servbasisamount: service.servbasis,
        };
        servs.push(new_servv);
   
        serviceList = [...servs];
      }

      form.setFieldsValue({ serviceList: serviceList });
    }
    if (action === 'update') {
      //const servs = getFieldValue(['elements', 'SERV']);

      let serviceList = form.getFieldValue('serviceList');

      if (service.ctetype === 'SERV') {
        const servs = [...serviceList];

        const updateserv = servs.map((element: any, index: number) =>
          element.cteid === service.cteid
            ? {
                ...element,
                ...service,
                is_updated: element.is_new ? false : true,
                oldservbasisamount: service.oldservbasisamount,
                stop: false,
              }
            : element
        );

        serviceList = [...updateserv];
        form.setFieldValue('serviceList', serviceList);
      }

      // //   let filtersList = getFilterList();
      //   filtersList.offerCriteria.push({
      //     critcode: 'SERVAMOUNT',
      //     critvalue: service.cterentalamount,
      //   });
    }
  };

  useEffect(() => {
    reset();
  }, [contract]);

  const getName = (param: string, cteid: any) => {
    let lcteid = form.getFieldValue('selectedElement');

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, param];
    } else {
      if (form.getFieldValue(['elements', 'FIN'])) {
        const index = form
          .getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item.cteid === lcteid);
        return ['elements', 'FIN', index, param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };

  const disableDaysBeforeToday = useCallback(
    (d) => {
      if (d == null) {
        return null;
      }

      let lastinvoicedate = form?.getFieldValue('lastinvoicedate');

      return (
        moment(lastinvoicedate) != null &&
        d.isBefore(moment(lastinvoicedate)) &&
        !d.isSame(moment(lastinvoicedate), 'day')
      );
    },
    [form?.getFieldValue('lastinvoicedate')]
  );

  const handleDeleteElement = (record: any) => {
    let serviceList = form
      .getFieldValue('serviceList')
      ?.filter((element: any) => element.cteid !== record.cteid);

    form.setFieldsValue({ serviceList: serviceList });
  };
  const columns_: any = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        comcode: 'Element.servcategorylabel',
        dataIndex: 'ctecategorylabel',
        width: 120,
        render: (value, record) => (
          <span
            style={{
              color:
                serviceToStop.findIndex((e) => e === record.cteid) !== -1
                  ? '#D3D3D3'
                  : 'black',
            }}
          >
            {record.ctetype === 'FIN'
              ? record.ctecategory
              : record.serviceResponse?.servcategorylabel ?? record.ctecategory}
          </span>
        ),
        fixed: 'left',
      },

      {
        comcode: 'Element.ctedescription',
        dataIndex: 'ctedescription',
        width: 180,
        render: (ctedescription, record, index) => (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <a
                style={{
                  color: record.stop && '#D3D3D3',
                  textDecoration: 'underline',
                }}
                onClick={() => {
                  !record.stop && setVisible(true);
                }}
              >
                {ctedescription}
              </a>
            )}
            modal={({ setVisible, visible }) => (
              <SimpleServElementModal
                offerid={contract?.offerid}
                visible={visible}
                onClose={() => setVisible(false)}
                record={{ ...record }}
                onSave={onSaveService!}
                updateService
                // form={form}
                cteidparent={record.cteidparent}
                finschedule={form.getFieldValue(
                  getName('conElemSchedules', elementID)
                )}
                ctegraceperiodduration={form.getFieldValue(
                  getName('ctegraceperiodduration', elementID)
                )}
                ctefinancedamount={form.getFieldValue(
                  getName('ctefinancedamount', elementID)
                )}
                cteinvestamount={form.getFieldValue(
                  getName('ctefinancedamount', elementID)
                )}
                assetamount={form.getFieldValue(
                  getName('ctefinancedamount', elementID)
                )}
                ctestartdate={form.getFieldValue('lastinvoicedate')}
                cteduration={form.getFieldValue('RemainingDuration')}
                assets={form.getFieldValue('assets')}
              />
            )}
          ></ModalControllerNV>
        ),
      },
      {
        comcode: 'Element.tpname',
        dataIndex: 'tpname',
        width: 100,
        render: (value, record) => (
          <span
            style={{
              color:
                serviceToStop.findIndex((e) => e === record.cteid) !== -1
                  ? '#D3D3D3'
                  : 'black',
            }}
          >
            {record.serviceResponse?.tpname ??
              record.commissionResponse?.commlabel}
          </span>
        ),
      },
      {
        comcode: 'Element.servbasislabel',
        dataIndex: 'servbasislabel',
        width: 100,
        render: (value, record) => (
          <span
            style={{
              color:
                serviceToStop.findIndex((e) => e === record.cteid) !== -1
                  ? '#D3D3D3'
                  : 'black',
            }}
          >
            {record.serviceResponse?.servbasislabel ??
              record.commissionResponse?.commbasislabel}
          </span>
        ),
      },

      {
        comcode: 'Element.servcalculationmethodlabel',
        dataIndex: 'servcalculationmethodlabel',
        width: 100,
        render: (value, record) => (
          <span
            style={{
              color:
                serviceToStop.findIndex((e) => e === record.cteid) !== -1
                  ? '#D3D3D3'
                  : 'black',
            }}
          >
            {record.serviceResponse?.servcalculationmethodlabel ??
              record.commissionResponse?.commcalculationmethodlabel}
          </span>
        ),
      },
      {
        comcode: 'perOrFixedAmount',
        dataIndex: 'perOrFixedAmount',
        render: (value, record) => (
          <span
            style={{
              color:
                serviceToStop.findIndex((e) => e === record.cteid) !== -1
                  ? '#D3D3D3'
                  : 'black',
            }}
          >
            {record.serviceResponse
              ? record.serviceResponse?.servcalculationmethod === 'PERCENT'
                ? toPercentage(record.serviceResponse?.servpercentage)
                : toCurrency(record.serviceResponse?.servfixedamount)
              : record.commissionResponse?.commcalculationmethod === 'PERCENT'
              ? toPercentage(record.commissionResponse?.commpercentage)
              : toCurrency(record.commissionResponse?.commfixedamount)}
          </span>
        ),
        width: 100,
        align: 'right',
      },

      {
        comcode: 'ctebasis',
        dataIndex: 'ctebasis',
        render: (value, record) => (
          <span
            style={{
              color:
                serviceToStop.findIndex((e) => e === record.cteid) !== -1
                  ? '#D3D3D3'
                  : 'black',
            }}
          >
            {record.serviceResponse?.servbasis === 'FINANCING'
              ? toCurrency(record.ctefinancedamount)
              : record.serviceResponse?.servbasis === 'FREE'
              ? toCurrency(record.servbasis)
              : toCurrency(record.cteinvestamount)}
          </span>
        ),
        width: 100,
        align: 'right',
      },
      {
        comcode: 'Element.servdurationlabel',
        dataIndex: 'servdurationlabel',
        width: 180,
        render: (value, record) => (
          <span
            style={{
              color:
                serviceToStop.findIndex((e) => e === record.cteid) !== -1
                  ? '#D3D3D3'
                  : 'black',
            }}
          >
            {record.serviceResponse?.servdurationlabel ??
              record.commissionResponse?.commdurationlabel}
          </span>
        ),
      },

      // {
      //   comcode: 'Element.ctenominalrate',
      //   dataIndex: 'ctenominalrate',
      //   render: (value, record) => (
      //     <span
      //       style={{
      //         color:
      //           serviceToStop.findIndex((e) => e === record.cteid) !== -1
      //             ? '#D3D3D3'
      //             : 'black',
      //       }}
      //     >
      //       {toRate(value)}
      //     </span>
      //   ),
      //   width: '20%',
      // },

      {
        comcode: 'Element.cteinstallmentamount',
        dataIndex: 'cteinstallmentamount',
        render: (value, record) => (
          <span
            style={{
              color:
                serviceToStop.findIndex((e) => e === record.cteid) !== -1
                  ? '#D3D3D3'
                  : 'black',
            }}
          >
            {toCurrency(value)}
          </span>
        ),
        width: 100,
      },

      {
        comcode: 'status',
        dataIndex: 'status',
        render: (value, record) => {
          return (
            <>
              {record?.is_new && (
                <Tag color="#87d068">
                  <GetLabel label="new" />
                </Tag>
              )}
              {record?.is_updated &&
                serviceToStop.findIndex((e) => e === record.cteid) === -1 && (
                  <Tag color="#2db7f5">
                    <GetLabel label="Update" />
                  </Tag>
                )}
              {record?.stop && <Tag color="#cd201f">Stoped</Tag>}
            </>
          );
        },
        fixed: 'right',
        width: 100,
        align: 'right',
      },
      {
        comcode: 'actions',
        key: 'operation',
        width: 180,
        render: (text, record, index) => (
          <Row>
            {record.pricing?.allowfinservice &&
              record.ctecalculationtype === 'FLAT' && (
                <Popconfirm
                  title="Do you want to finance this element?"
                  //   onConfirm={() => onConvertServToFinServ(record)}
                >
                  <ConvertButton onlyIcon />
                </Popconfirm>
              )}

            {record.is_new && (
              <Popconfirm
                title="Do you want to delete this element?"
                onConfirm={() => handleDeleteElement(record)}
              >
                <DeleteButton style={{ marginLeft: 5 }} onlyIcon />
              </Popconfirm>
            )}

            {!record.is_new &&
            serviceToStop.findIndex((e) => e === record.cteid) === -1 ? (
              <>
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <Button
                      htmlType="button"
                      // onClick={() => {
                      //   let newlist: any[] = [...serviceToStop, record.cteid];
                      //   setServiceToStop(newlist);
                      //   record.stop = true;
                      //   setValueByNamePath(
                      //     form,
                      //     ['serviceList', index, 'stop'],
                      //     true
                      //   );
                      // }}
                      type="primary"
                      style={{ background: 'red !important', marginLeft: 5 }}
                      onClick={() => {
                        !record.stop && setVisible(true);
                      }}
                      disabled={mode === 'REAL'}
                    >
                      Update
                    </Button>
                  )}
                  modal={({ setVisible, visible }) => (
                    <SimpleServElementModal
                      offerid={form.getFieldValue('offerid')}
                      visible={visible}
                      onClose={() => setVisible(false)}
                      record={{ ...record }}
                      onSave={onSaveService!}
                      updateService
                      // form={form}
                      cteidparent={record.cteidparent}
                      finschedule={form.getFieldValue(
                        getName('conElemSchedules', elementID)
                      )}
                      ctegraceperiodduration={form.getFieldValue(
                        getName('ctegraceperiodduration', elementID)
                      )}
                      ctefinancedamount={form.getFieldValue(
                        getName('ctefinancedamount', elementID)
                      )}
                      cteinvestamount={form.getFieldValue(
                        getName('ctefinancedamount', elementID)
                      )}
                      assetamount={form.getFieldValue(
                        getName('ctefinancedamount', elementID)
                      )}
                      ctestartdate={form.getFieldValue('lastinvoicedate')}
                      cteduration={form.getFieldValue('RemainingDuration')}
                      assets={form.getFieldValue('assets')}
                    />
                  )}
                ></ModalControllerNV>
                <Button
                  htmlType="button"
                  onClick={() => {
                    let newlist: any[] = [...serviceToStop, record.cteid];
                    setServiceToStop(newlist);
                    record.stop = true;
                    setValueByNamePath(
                      form,
                      ['serviceList', index, 'stop'],
                      true
                    );
                  }}
                  disabled={mode === 'REAL'}
                  danger
                  style={{ background: 'red !important', marginLeft: 5 }}
                >
                  Stop
                </Button>
              </>
            ) : (
              <Button
                htmlType="button"
                onClick={() => {
                  continueService(record);
                }}
                type="primary"
                hidden={record.is_new}
                disabled={mode === 'REAL'}
                style={{ marginLeft: 5 }}
              >
                Continue
              </Button>
            )}
            {record.ctetype === 'FINSERV' ? (
              <FinancialScheduleModal
                comcode="P.S"
                currcode={record.currcode}
                finElement={record}
                controller={
                  <ScheduleButton
                    size="large"
                    comcode="P.S"
                    twoToneColor="blue"
                    disabled={
                      serviceToStop.findIndex((e) => e === record.cteid) !== -1
                    }
                  ></ScheduleButton>
                }
              />
            ) : (
              <ServiceScheduleModal
                currcode={record.currcode}
                financialSchedule={record.conElemSchedules}
                controller={
                  <ScheduleButton
                    onlyicon
                    comcode="P.S"
                    twoToneColor="blue"
                    style={{
                      height: 40,
                      marginLeft: 5,
                      marginRight: 5,
                      marginBottom: 5,
                    }}
                    disabled={
                      serviceToStop.findIndex((e) => e === record.cteid) !== -1
                    }
                  />
                }
              />
            )}
            {record.conElemSpreading?.length > 0 ? (
              <SpreadingScheduleModal
                financialSchedule={record.conElemSpreading}
                controller={
                  <ScheduleButton
                    comcode="S.P"
                    twoToneColor="red"
                    style={{
                      height: 40,
                      marginLeft: 5,
                      marginRight: 5,
                      marginBottom: 5,
                    }}
                    disabled={
                      serviceToStop.findIndex((e) => e === record.cteid) !== -1
                    }
                  />
                }
              />
            ) : null}
            {record.conElemIFRS?.length > 0 ? (
              <IfrsScheduleModal
                financialSchedule={record.conElemIFRS}
                controller={
                  <ScheduleButton
                    comcode="IFRS"
                    twoToneColor="green"
                    style={{
                      height: 40,
                      marginLeft: 5,
                      marginRight: 5,
                      marginBottom: 5,
                    }}
                    disabled={
                      serviceToStop.findIndex((e) => e === record.cteid) !== -1
                    }
                  />
                }
              />
            ) : null}
          </Row>
        ),
        fixed: 'right',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contract, serviceToStop, form]
  );

  const continueService = (service: any) => {
    let newlist: any[] = serviceToStop.filter((x) => x !== service.cteid);
    setServiceToStop(newlist);
    let serviceList = form.getFieldValue('serviceList');

    let remainDuration = form.getFieldValue('remainDuration');

    const {
      FIN = [],
      FINOUT = [],
      SPV = [],
      SERV = [],
      FEES = [],
      COMM = [],
      FINSERV = [],
      SERVOUT = [],
    } = groupBy(contract?.conElements, 'ctetype');

    if (service.ctetype === 'SERV') {
      const servs = [...serviceList];

      const updateserv = servs.map((element: any, index: number) => {
        if (element.cteid === service.cteid) {
          const serv: any = SERV.find((s: any) => s.cteid === service.cteid);

          const notInvoicedScheduleSERV = contract?.conElements
            ?.find((e) => e.cteid === element.cteid)
            ?.conElemSchedules.filter((s) => s.ciid === null);

          let lastinvoicedateService: string = '';
          if (
            !isNil(notInvoicedScheduleSERV) &&
            notInvoicedScheduleSERV.length > 0
          ) {
            lastinvoicedateService = notInvoicedScheduleSERV[0]?.ctsduedate;
          }

          const remainDurationService =
            notInvoicedScheduleSERV?.filter(
              (e) => e.ctsduedate >= lastinvoicedateService
            ).length ?? 0;

          if (serv) {
            return {
              ...serv,
              is_new: false,
              is_updated: false,
              stop: false,
              oldservfixedamount: serv?.servfixedamount,
              servpercentage: serv?.servpercentage,
              oldservpercentage: serv?.servpercentage,
              oldservbasisamount: serv?.servbasisamount,
              remainingduration:
                remainDurationService > remainDuration
                  ? remainDuration
                  : remainDurationService,
              oldremainingduration:
                remainDurationService > remainDuration
                  ? remainDuration
                  : remainDurationService,
              overallduration: serv.cteduration,
              oldoverallduration: serv.cteduration,
            };
          } else {
            return element;
          }
        } else {
          return element;
        }
      });

      serviceList = [...updateserv];
      form.setFieldValue('serviceList', serviceList);
    }
  };

  const columnsDispaly: any = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        comcode: 'prilabel',
        dataIndex: 'prilabel',
        render: (val, record) => (
          <span
            style={{
              color: record?.servtargetstatus === 'STOP' ? 'red' : 'black',
            }}
          >
            {val}
          </span>
        ),
      },
      {
        comcode: 'oldoverallduration',
        dataIndex: 'oldoverallduration',
        render: (value, record) => value,
        align: 'right',
      },

      {
        comcode: 'overallduration',
        dataIndex: 'overallduration',
        render: (value, record) => value,
        align: 'right',
      },

      {
        comcode: 'oldremainingduration',
        dataIndex: 'oldremainingduration',
        render: (value, record) => value,
        align: 'right',
      },

      {
        comcode: 'remainingduration',
        dataIndex: 'remainingduration',
        render: (value, record) => value,
        align: 'right',
      },

      {
        comcode: 'oldservbasisamount',
        dataIndex: 'oldservbasisamount',
        render: (value, record) => toCurrency(value),
        align: 'right',
      },

      {
        comcode: 'servbasisamount',
        dataIndex: 'servbasisamount',
        render: (value, record) => toCurrency(value),
        align: 'right',
      },

      {
        comcode: 'oldservfixedamount',
        dataIndex: 'oldservfixedamount',
        render: (value, record) => toCurrency(value),
        align: 'right',
      },

      {
        comcode: 'servfixedamount',
        dataIndex: 'servfixedamount',
        render: (value, record) => toCurrency(value),
        align: 'right',
      },

      {
        comcode: 'status',
        dataIndex: 'status',
        render: (value, record) => {
          return (
            <>
              {record?.servtargetstatus === 'NEW' && (
                <Tag color="#87d068">{record.servtargetstatus}</Tag>
              )}
              {record?.servtargetstatus === 'UPDATE' && (
                <Tag color="#2db7f5">{record?.servtargetstatus}</Tag>
              )}
              {record?.servtargetstatus === 'STOP' && (
                <Tag color="#cd201f"> {record?.servtargetstatus}</Tag>
              )}
            </>
          );
        },
        fixed: 'right',
        align: 'right',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <DF.Provider pagcode="tabservrescheduling">
      <Spin spinning={isFetching}>
        <Row gutter={10}>
          <UtinaCard
            comcode="tabServRescheduling"
            level={5}
            styleCard={{
              color: '#000',
              paddingTop: 2,
              paddingBottom: 25,
            }}
            lg={6}
          >
            <FormInput
              name="mode"
              rules={[{ required: true }]}
              initialValue={mode}
            >
              <div className="radio-group">
                <span
                  className={
                    mode === 'SIMUL'
                      ? 'radio-button radio-button-checked'
                      : 'radio-button'
                  }
                  onClick={() => {
                    setMode('SIMUL');
                    form.setFieldsValue({ modid: undefined, mode: 'SIMUL' });
                    reset();
                  }}
                >
                  SIMUL
                </span>
                <span
                  className={
                    mode === 'REAL'
                      ? 'radio-button radio-button-checked'
                      : 'radio-button'
                  }
                  onClick={() => {
                    reset();
                    setMode('REAL');
                    form.setFieldValue('mode', 'REAL');
                  }}
                >
                  REAL
                </span>
              </div>
            </FormInput>

            <FormInput
              col
              xs={20}
              name="effectDate"
              rules={[{ required: true }]}
              shouldUpdate
            >
              <Select
                size="middle"
                style={{ width: '100%' }}
                disabled={mode === 'REAL'}
                onChange={handleEffectDateChange}
              >
                {optionDates}
              </Select>
            </FormInput>

            {mode === 'REAL' && (
              <FormInput
                name="modid"
                labelAlign="left"
                rules={[{ required: mode === 'REAL' }]}
              >
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  onSelect={handleFinModSelect}
                  onClear={() => {
                    reset();
                  }}
                >
                  {modList?.map((e: any, index: number) => (
                    <Select.Option key={index} value={e.modid}>
                      {e.ctreference + ' - ' + e.modid + ' - ' + e.modcomment}
                    </Select.Option>
                  ))}
                </Select>
              </FormInput>
            )}
          </UtinaCard>
          <UtinaCard
            level={5}
            comcode="FeesFormula"
            styleCard={{
              color: '#000',
              paddingTop: 2,
              paddingBottom: 25,
            }}
            lg={6}
          >
            <Row>
              <FormInput
                col
                xs={24}
                name="feesFormula"
                //rules={[{ required: true }]}
              >
                <PricingListFilteredSelect
                  //disabled={!getFieldValue('offerid')}
                  allowClear
                  params={{
                    offerid: contract?.offerid ?? 0,
                    ctetype: 'MODFEES', // Modifictaion fees
                    prcode: contract?.prcode ?? '',
                    entity: '',
                    entityid: 0,
                    tpid: contract?.tpidclient ?? 0,
                  }}
                  onClear={() => {
                    form?.setFieldValue('feesAmount', 0);
                  }}
                  disabled={mode === 'REAL'}
                  onChange={(e) => calculateFees(e)}
                />
              </FormInput>
            </Row>
            <Row>
              <FormInput name="feesAmount" shouldUpdate>
                <InputCurrency
                  currcode={
                    contract?.currcode ?? localStorage.getItem('currcode') ?? ''
                  }
                  defaultValue={0}
                  disabled={
                    form?.getFieldValue('feesFormula') === undefined ||
                    mode === 'REAL'
                  }
                />
              </FormInput>
            </Row>
          </UtinaCard>

          <UtinaCard
            comcode="situationEffectDate"
            level={5}
            styleCard={{
              color: '#000',
              paddingTop: 2,
              paddingBottom: 25,
            }}
            lg={11}
          >
            <Row>
              <FormInput
                col
                xs={12}
                name="duree"
                //rules={[{ required: true }]}
              >
                <Value />
              </FormInput>

              <FormInput
                col
                xs={12}
                name="RemainingDuration"
                //rules={[{ required: true }]}
              >
                <Value />
              </FormInput>

              <FormInput
                col
                xs={12}
                name="rental"
                //rules={[{ required: true }]}
              >
                <Value formatter={toCurrency} />
              </FormInput>

              <FormInput
                col
                xs={12}
                name="lastinvoicedate"
                //rules={[{ required: true }]}
              >
                <Value />
              </FormInput>
            </Row>
          </UtinaCard>
          {/* <Col md={5}>
                <div className="radio-group">
                  <span
                    className={
                      mode === 'SIMUL'
                        ? 'radio-button radio-button-checked'
                        : 'radio-button'
                    }
                    onClick={() => {
                      setMode('SIMUL'); 
                    }}
                  >
                    SIMUL
                  </span>
                  <span
                    className={
                      mode === 'REAL'
                        ? 'radio-button radio-button-checked'
                        : 'radio-button'
                    }
                    onClick={() => {
                      setMode('REAL');
                    }}
                  >
                    REAL
                  </span>
                </div>
              </Col> */}
        </Row>
        <UtinaCard comcode="tabServRescheduling" level={5}>
          <Row gutter={10}>
              {/* <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  return (
                    <DataGrid
                      scroll={{ x: 1000, y: 900 }}
                      columns={columns}
                      rowKey={(element, index) => element.cteid}
                      dataSource={getFieldValue('elemList')}
                      pagination={false}
                      isLoading={isLoading === 'POFF'}
                    />
                  );
                }}
              </Form.Item> */}

              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const SERV: any[] = Array.isArray(
                    getFieldValue('serviceList')
                  )
                    ? getFieldValue('serviceList')
                    : [];

                    console.log('SERV::',SERV)

                  const elements = [...SERV];

                  // const obj = {
                  //   finschedule: form.getFieldValue(
                  //     getName('conElemSchedules', elementID)
                  //   ),
                  //   ctegraceperiodduration: form.getFieldValue(
                  //     getName('ctegraceperiodduration', elementID)
                  //   ),
                  //   ctefinancedamount: form.getFieldValue(
                  //     getName('ctefinancedamount', elementID)
                  //   ),
                  //   cteinvestamount: form.getFieldValue(
                  //     getName('ctefinancedamount', elementID)
                  //   ),
                  //   assetamount: form.getFieldValue(
                  //     getName('ctefinancedamount', elementID)
                  //   ),
                  //   ctestartdate: form.getFieldValue(
                  //     getName('ctestartdate', elementID)
                  //   ),
                  //   cteduration: form.getFieldValue(
                  //     getName('cteduration', elementID)
                  //   ),
                  // };

                  let cteduration = form.getFieldValue('RemainingDuration');
                  return (
                    <>
                      {mode !== 'REAL' && (
                        <ModalControllerNV
                          content={({ setVisible, visible }) => (
                            <Row justify="end">
                              <ButtonOperation
                                comcode="AddService"
                                htmlType="button"
                                type="primary"
                                onClick={() => {
                                  setVisible(true);
                                }}
                                disabled={mode === 'REAL'}
                              />
                            </Row>
                          )}
                          modal={({ setVisible, visible }) => (
                            <SimpleServElementModal
                              offerid={form.getFieldValue('offerid')}
                              visible={visible}
                              onClose={() => setVisible(false)}
                              onSave={onSaveService}
                              // form={form}
                              assetid={0}
                              cteidparent={form?.getFieldValue(
                                'cteidparent'
                              )}
                              finschedule={form.getFieldValue(
                                getName('conElemSchedules', elementID)
                              )}
                              ctegraceperiodduration={form.getFieldValue(
                                getName('ctegraceperiodduration', elementID)
                              )}
                              ctefinancedamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                              cteinvestamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                              assetamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                              ctestartdate={form.getFieldValue(
                                'lastinvoicedate'
                              )}
                              cteduration={cteduration}
                              assets={form.getFieldValue('assets')}
                            />
                          )}
                        ></ModalControllerNV>
                      )}
                      <DataGrid
                        scroll={{ x: 800, y: 900 }}
                        columns={mode === 'REAL' ? columnsDispaly : columns_}
                        rowKey={(element, index) => element.cteid}
                        dataSource={elements}
                        pagination={false}
                        isLoading={isLoading === 'POFF'}
                        hideExtraAction
                      />
                    </>
                  );
                }}
              </Form.Item>
         
          </Row>
        </UtinaCard>
      </Spin>
    </DF.Provider>
  );
};
export default TabReschedulingService;
